<template>
  <div v-if="!isLoading">
    <div v-if="state==='edit' && record">
      <ElButton
        @click="state='index'"
        icon="el-icon-back"
      >
        Back
      </ElButton>
      <h1>{{ myTitle }}</h1>
      <ElRow :gutter="20">
        <ElCol
          v-if="record.thumb"
          :span="4"
        >
          <img style="max-width: 300px" :src="record.thumb">
        </ElCol>
        <ElCol :span="16">
          <br>
          <ElUpload
            :action="'/api/upload?'+record.uuid"
            :headers="iconHeaders"
            :on-success="uploadDone"
            :show-file-list="false"
            :before-upload="isImage"
            accept="image/*"
          >
            <ElButton
              size="small"
              type="primary"
            >
              Upload iconic
            </ElButton>
          </ElUpload><br>
        </ElCol>
      </ElRow>

<ElRow>
  <ElCol :span="24">

      <label>
        Title <input
          type="text"
          v-model="record.title"
        >
      </label>
      <label>
        Author <input
          type="text"
          v-model="record.author"
        >
      </label>
      <label>
        Slug <input
          type="text"
          v-model="record.slug"
        >
      </label>
      <!-- note the mixup in license & copyright!
      we need to move from string-property to relation! -->

      <!-- the string--->
      <label>
        License <input
          type="text"
          v-model="record.copyright"
        >
      </label>

      <!-- the relation -->
      <label>
        License (not connected in frontend yet)
        <hiCopyright
          @remove="removeCopyright"
          @input="changeCopyright"
          :value="getLicense"
        />
      </label>


      <label>
        Summary <textarea
          rows="10"
          type="text"
          v-model="record.summary"
        />
      </label>
      <label>
        Intro <textarea
          rows="10"
          type="text"
          v-model="record.intro"
        />
      </label>
      <label>
        Outcomes <textarea
          rows="10"
          type="text"
          v-model="record.outcomes"
        />
      </label>
      <label>
        Acknowledgements <textarea
          rows="10"
          type="text"
          v-model="record.acknowledgements"
        />
      </label>

</ElCol>
</ElRow>

<el-divider/>


<ElRow>
  <ElCol :span="24">
    <p>Notes:<ul>
      <li>- Add button will show when box is hovered</li>
      <li>- Label can be removed with ALT-click</li>
    </ul>
    </p>
      <hiCheckbox
        v-model="record.duration"
        icon="fa-clock-o"
        :add="true"
        set="duration"
        :key="`a_${recordLoaded}`"
      />
      <hiCheckbox
        v-model="record.age"
        icon="fa-user"
        :add="true"
        set="age"
        :key="`b_${recordLoaded}`"
      />
      <hiCheckbox
        v-model="record.tags"
        icon="fa-th-list"
        :add="true"
        set="tag"
        :key="`c_${recordLoaded}`"
      />

</ElCol>
</ElRow>
      <el-divider/>


<ElRow>
  <ElCol :span="26">
      <hiCheckbox
        v-model="record.thinking"
        icon="fa-th-list"
        set="thinking"
        @upWhy="upWhy"
        view="why"
        :key="`d_${recordLoaded}`"
      />
      <hiCheckbox
        v-model="record.methods"
        icon="fa-th-list"
        set="methods"
        @upWhy="upWhy"
        view="why"
        :key="`e_${recordLoaded}`"
      />
      <hiCheckbox
        v-model="record.challenges"
        icon="fa-th-list"
        set="challenges"
        @upWhy="upWhy"
        view="why"
        :key="`f_${recordLoaded}`"
      />

</ElCol>
</ElRow>

<ElRow>
  <ElCol :span="24">
    <h3>debug</h3>
      <pre>age: {{ record.age }}</pre>
      <pre>d: {{ record.duration }}</pre>
      <pre>t: {{ record.tags }}</pre>

      </ElCol>
</ElRow>


      <el-divider/>



  <ElRow :gutter="20">
    <elCol :span="24">
  <el-collapse>
   <el-collapse-item title="Relate to other Learning Activities">
      <ul>
        <li
          :key="la.uuid"
          v-for="la in record.las"
        >
          <label>
            <input
              type="checkbox"
              v-model="related"
              :value="la.uuid"
            >{{ la.title }}
          </label>
        </li>
      </ul>

      </el-collapse-item>
      </el-collapse>
    </elCol>
    </ElRow>

  <ElRow :gutter="20">
    <ElCol :span="24">
      <br>
      <ElButton @click="saveLA">
        Save Learning Activity
      </ElButton>

</elCol></ElRow>
    </div>


    <div v-if="state==='upload' && record">
      <ElRow>
             <ElButton
        @click="state='index'"
        icon="el-icon-back"
      >        Back
      </ElButton>
    </ElRow>

    <ElRow>
      <h1>Manage materials for <b>{{record.title }}</b></h1>
      <ElCol :span="6">
      <img style="max-width:160px" :src="record.thumb"/>
      </ElCol>
      <ElCol :span="6">
      <ElUpload
        xlist-type="picture-card"
        :action="'/api/upload?'+record.uuid"
        :headers="iconHeaders"
        :on-success="uploadDone"
        :show-file-list="false"
      >
        <el-button size="small" type="primary">Upload iconic image</el-button>
      </ElUpload>
      </ElCol>
    </ElRow>


      la: {{ record.uuid }}<br/>
      {{record.thumb}}
      <h4 v-if="myAssets.new && myAssets.new.length>0">
        New Downloads
      </h4>
      <table v-if="myAssets.new  && myAssets.new.length>0">
        <thead>
          <tr>
            <th colspan="2">
              Filename
            </th>
            <th>Title</th>
            <th>Type</th>
          </tr>
        </thead>
        <tbody>
          <tr :key="asset.uuid" v-for="asset in myAssets.new">
            <td colspan="2">
              {{ asset.filename }}
            </td>
            <td width="240">
              <input
                v-model="asset.title"
                type="text"
                placeholder="Title..."
                size="30"
              >
            </td>
            <td>
              <ElSelect
                v-model="asset.linktype"
                :value="''"
              >
                <ElOption
                  v-for="item in $store.getters['forms']['linktypes']"
                  :key="item.uuid"
                  :label="item.name"
                  :value="item.uuid"
                >
                  <span style="float: left">
                    <small style="text-transform: lowercase">
                      {{ item.interest }}
                    </small> &ndash; {{ item.name }}
                  </span>
                  <span style="float: right">
                    <img :src="item.icon||'/static/la/hi-blank.png'">
                  </span>
                </ElOption>
              </ElSelect>
            </td>

            <td>
              <ElButton
                size="small"
                @click="saveNew(asset)"
                type="primary"
              >
                Save
              </ElButton>
            </td>
          </tr>
        </tbody>
      </table>


      <h4 v-if="myAssets.new">
        Existing Downloads
      </h4>
      <table v-if="myAssets">
        <thead>
          <tr>
            <th colspan="2">
              Filename
            </th>
            <th>Title</th>
            <th>Type</th>
            <th />
          </tr>
        </thead>
        <tbody>
          <tr :key="asset.uuid" v-for="asset in myAssets.existing">
            <td colspan="2">
              {{ asset.filename }}
            </td>
            <td width="240">
              <input
                @change="setTitle($event.target.value,asset.uuid)"
                :value="asset.title"
                type="text"
                placeholder="Title..."
                size="30"
              >
            </td>
            <td>
              <ElSelect :value="asset.link.uuid">
                <ElOption
                  v-for="item in $store.getters['forms']['linktypes']"
                  :key="item.uuid"
                  :label="item.name"
                  :value="item.uuid"
                >
                  <span style="float: left">
                    <small style="text-transform: lowercase">
                      {{ item.interest }}
                    </small> &ndash; {{ item.name }}
                  </span>
                  <span style="float: right">
                    <img :src="item.icon||'/static/la/hi-blank.png'">
                  </span>
                </ElOption>
              </ElSelect>
              <span :class="asset.link.interest">
                &#8214;
              </span>
            </td>

            <td>
              <ElButton
                @click="deleteAsset(record, asset)"
                round
                icon="el-icon-delete"
              />
            </td>
          </tr>
        </tbody>
      </table>
      <ElUpload
        xclass="avatar-uploader"
        xlist-type="picture-card"
        :action="'/api/upload?'+record.uuid"
        :headers="headers"
        :on-success="uploadDone"
        :show-file-list="false"
      >
       <el-button size="small" type="primary"><i class="el-icon-plus" /> Add file</el-button>
      </ElUpload>
    </div>



    <div
      v-if="state==='index'"
      class="dataTable"
    >
      <ElButton
        type="primary"
        style="float:right"
        @click="createLA"
        icon="el-icon-plus"
      >
        Add New
      </ElButton>
      <h1>Learning Activities</h1>

      <table
        v-if="state==='index'"
        class="dataTable"
      >
        <thead>
          <tr>
            <th>Name</th>
            <th>Author</th>
            <th>Slug</th>
            <th>License</th>
            <th>Status</th>
            <th />
          </tr>
        </thead>
        <tbody>
          <tr class="alternate" :key="r.uuid" v-for="r in items">
            <td width="340">
              {{ r.title }}
            </td>
            <td>{{ r.author }}</td>
            <td>{{ r.slug }}</td>
            <td>{{ r.license }}</td>
            <td width="180">xxstatus:
              <hiStatus
                @input="setStatus(r)"
                v-model="r.status"
              />
            </td>

            <td
              width="200"
              align="right"
            >
              <ElButtonGroup style="margin: 20px 0">
                <a
                  target="_new"
                  href=""
                >
                  <ElButton
                    title="View"
                    type="primary"
                    size="mini"
                    icon="el-icon-view"
                  />
                </a>
                <ElButton
                  @click.stop="upload(r.uuid)"
                  title="Upload"
                  type="primary"
                  size="mini"
                  icon="el-icon-upload2"
                />
                <ElButton
                  @click.stop="edit(r.uuid)"
                  title="Edit"
                  type="primary"
                  size="mini"
                  icon="el-icon-edit"
                />
                <ElButton
                  @click.stop="deleteLA(r.uuid)"
                  title="Delete"
                  type="danger"
                  size="mini"
                  icon="el-icon-delete"
                />
              </ElButtonGroup>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>


<script>
import hiCheckbox from '@/components/hiCheckbox.vue'
import hiStatus from '@/components/hiStatus.vue'
import hiCopyright from '@/components/hiCopyright.vue'

export default {
  name: 'LearningActivityEditor',

  components: {
    hiCheckbox,
    hiCopyright,
    hiStatus
  },


  watch: {
    why: {
      deep: true
    },

    state () {
      this.myTitle='Edit Learning Activity'
    }

  },

  mounted () {
    console.log("--> mount la-editor")

    console.log("FORMS: ", this.$store.getters['forms'])


    let vm = this
    vm.isLoading = true
    this.$API.get('/la')
       .then((resp) => {
         this.items = resp.data.data
         vm.isLoading=false

       }).catch(e => {
         this.$alert(e.response.data.errorCode, 'API Error', {
          confirmButtonText: 'OK'
        })
     })
    // this.isLoading = false
  },

  computed: {
    getLicense () {
      if (this.record.license && this.record.license.uuid) {
        return this.record.license.uuid
      }
      return null
    }

  },

  methods: {

    loadData () {
      this.$API.get('/la')
         .then((resp) => {
           this.items = resp.data.data
         }).catch(e => {
           this.$alert(e.response.data.errorCode, 'API Error', {
            confirmButtonText: 'OK'
          })
       })
    },

    // getStatus (r) {
    //   console.log("gs: ", r)
    //   if (r && r.status && r.status.uuid) {
    //     return "sds"
    //   }
    // },

    setStatus (e) {
      this.$API.post("/admin/la/status", {
        la: e.uuid,
        status: e.status
      }).then((e) => {
        this.$message({message:"Status changed.", type:'success'})
      })
    },

    deleteLA (la) {

      let res = confirm("Delete Learning Activity?")
      if (res) {
        this.$API.post("/admin/la/delete", {uuid: la})
        .then((r) => {
          this.$message({message:'Deleted', type:'error'})
          this.loadData()
        })
      }

    },

    createLA () {
      // let API create a new empty LA with just the uuid
      this.myTitle='Add Learning Activity'
      this.$API.post("/admin/la/create")
      .then((r) => {
        // edit it
        // this.record = r.data.data
        return this.edit(r.data.data)
      })

    },

    isImage (file) {
      console.log("isImage: ", file)
    },

    deleteAsset (record, asset) {
      console.log("delete asset ", asset, " from ", record.uuid)
      this.$API.delete(`/admin/la/asset/${this.record.uuid}`, {data: asset})
      .then((r) => {
        this.getMyAssets(this.record.uuid)
      })

    },

    saveNew (asset) {
      this.$API.post(`/admin/la/asset/${this.record.uuid}`, asset)
      .then((r) => {
        this.getMyAssets(this.record.uuid)
      })
    },

    setTitle (e,v) {
      console.log("set title: ", e,v)
    },

    uploadDone (r) {
      console.log("upload done")
      this.getMyAssets(this.record.uuid)
    },

    saveLA (r) {
      console.log("--> SAVELA : ", this.record.uuid)
      console.log("--> SAVE LA ", r)
      console.log("insave why: ", this.why)
      delete this.record.rels
      console.log(JSON.stringify(this.record, null, 4))


      console.log("WHY: ", JSON.stringify(this.why, null,4))
      this.$API.post(`/admin/la/${this.record.uuid}`, { record: this.record, related: this.related })
      .then((r) => {
        this.state='index'
        this.$API.get('/la').then((resp) => {
         this.items = resp.data.data
        })
      })

    },

    getMyAssets (uuid) {
      console.log("get assets for: ",uuid)
      this.$API.get(`/admin/la/assets/${uuid}`)
      .then((r) => {
        console.log("getAssets ", r)
        this.myAssets = r.data.data
      })
    },

    upWhy (data) {
      let vm = this
      console.log("update why: ", data, " for set: ", data.set)
      console.log("vm.why: ", vm.why)
      if (vm.why[data.set]===undefined) {
        vm.why[data.set] = {}
      }
      for (let [k,v] of Object.entries(data.why)) {

        vm.why[data.set][k] = v
        //console.log("why: ", vm.why)
        //console.log("k: ", k, " v:", v)
      }
    },

    edit (uuid) {
      //console.log("edit ", uuid)
      this.state = 'edit'

      return this.$API.get('/la/'+uuid).then((resp) => {
        //console.log("got la ", resp.data.data)
        //this.record = JSON.parse(JSON.stringify(resp.data.data))
        this.record = resp.data.data
        this.related = this.record.related
        this.recordLoaded++
      })
    },

    upload (uuid) {
      console.log("upload ", uuid)
      this.state = 'upload'
      this.$API.get('/la/'+uuid).then((resp) => {
        console.log("got la ", resp.data.data)
        this.record = resp.data.data
      })
      this.getMyAssets(uuid)

    },

    removeCopyright (item) {
      this.$API.post("/admin/la/rights/remove", {
         item: this.record.uuid,
         copyright: item
      })
    },

    changeCopyright (item) {
      this.$API.post("/admin/la/rights/change", {
        item: this.record.uuid,
        copyright: item
      })
    }
  },


  data () {
    return {
      isLoading: true,
      recordLoaded: 1,  // key for child updates
      myTitle: 'Edit Learning Activity',
      related: [],
      items: [],
      c: {},
      state: 'index',
      record: {},
      duration: [],
      age: [],
      tags: [],
      thinking: [],
      why: {},
      myAssets: [],
      cType: '',
      headers: {
        // these are needed in the API to identify the user
        'X-Session': this.$store.state.session.sessionId,
        'X-Process': 'laAsset'
      },

      iconHeaders: {
        'X-Session': this.$store.state.session.sessionId,
        'X-Process': 'thumbLA'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
   @import '../Style.scss';

   table {
    border-collapse:separate;
  }

  .datatable tr:nth-child(odd) {
    background-color: #ccc;
  }

  .datatable td {
    padding: 1em;
  }

   .datatable tr {
    border-bottom: 2px solid green;
    padding-bottom: 3em !important;
   }

   span.teacher {
      display:block;
      float: right;
      background-color: $teacher;
      color: $teacher;

   }

   span.student {
    background-color: $student;

    color: $student;
      display:block;
      float: right;

   }

   label {
    //background-color: #eee;
    margin-top: 1em;
   }


hr {
    clear:both;
    display:block;
    height: 1px;
    border: 0px;
    border-top: 1px solid black;
    padding: 0px;
    padding-bottom: 10px;
    margin: 10px;
}

tr.alternate:nth-child(even) {

  background: #eee;
}

</style>